import { useRouter } from 'next/router';
import $ from 'jquery';
import ApiUrl from '../url.json';
import { useState, useEffect, useRef } from 'react';
import React from 'react';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import { useSession, signIn, signOut } from "next-auth/react";
import SignOut from "./components/signOut";
import styles from "../styles/index.module.css";
import axios from "axios";
import ResetPassModal from "./components/resetPassModal"
import cancelRequests from '../utils/cancelRequests';
import { useQueryClient } from '@tanstack/react-query';
import { staleTime, gcTime } from "../utils/frontendConstant"

export default function Login({ }) {
    const { data: session, update } = useSession();
    const urlParams = new URLSearchParams(window.location.search);
    const isRedirectingRef = useRef(false);
    const id = urlParams.get("id");
    const jobid = urlParams.get("jobid");
    const jobtype = urlParams.get("jobtype");
    const router = useRouter();
    const { redirectTo } = router.query; // Extract redirectTo from query parameters
    const [resetPassOpen, setResetPassOpen] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isNewUser, setIsNewUser] = useState(false);

    const [showModal, setShowModal] = useState(false);
    const isMountedRef = useRef(true);
    const { createCancelableAxiosOptions } = cancelRequests();
    const hasFetchedUser = useRef(false);
    const queryClient = useQueryClient();


    const callbackUrl = urlParams.get("callbackUrl");

    // Helper function for default menu
    const getDefaultRouteFromMenu = () => {
        try {

            let raw = localStorage.getItem('menubardata');
            if (!raw) return callbackUrl ? `/jobs/all-jobs?callbackUrl=${encodeURIComponent(callbackUrl || '')}` : `/jobs/all-jobs`;

            let menuBar = JSON.parse(raw);

            if (menuBar?.menubar) {
                menuBar = menuBar.menubar;
            }

            const dashboardItems = menuBar?.dashboard;
            if (!Array.isArray(dashboardItems) || dashboardItems.length === 0) {
                return callbackUrl ? `/jobs/all-jobs?callbackUrl=${encodeURIComponent(callbackUrl || '')}` : `/jobs/all-jobs`
            }

            let matchedDash = dashboardItems.find(item => item.defaultMenu) || dashboardItems[0];

            let targetUrl =
                (Array.isArray(matchedDash.sideMenu) && matchedDash.sideMenu.length > 0)
                    ? matchedDash.sideMenu[0].URL
                    : matchedDash.URL;

            // Final URL + carry callbackUrl forward
            return callbackUrl ? `${targetUrl}?callbackUrl=${encodeURIComponent(callbackUrl || '')}` : `${targetUrl}`;

        } catch (e) {
            console.error("Error reading default route:", e);
            return callbackUrl ? `/jobs/all-jobs?callbackUrl=${encodeURIComponent(callbackUrl || '')}` : `/jobs/all-jobs`;
        }
    };
    const checkCompanyIsActive = async (companyId) => {
        try {
            const { data } = await axios.get(
                `${ApiUrl.newUrl}/api/getCompanyActiveStatusByID/${companyId}`
            );

            return data?.success === true && data?.isActive === true;

        } catch (err) {
            console.error("Company status check failed", err);
            return false;
        }
    };

    useEffect(() => {
        isMountedRef.current = true;
        const handleLogin = async () => {
            if (session && (!localStorage.getItem("jwt") || localStorage.getItem("jwt") === "undefined") && !hasFetchedUser.current) {
                try {
                    hasFetchedUser.current = true;
                    if (session.user.email) { // AD login
                        const userid = session.user.email;
                        const userADtoken = session.accessToken;
                        const body = JSON.stringify({
                            "emailid": userid,
                            "adtoken": userADtoken,
                        });

                        const config = createCancelableAxiosOptions({
                            method: 'post',
                            url: ApiUrl.newUrl + '/api/getUser',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            data: body,
                        });

                        const response = await axios(config);
                        // axios(config)
                        //     .then(function (response) {
                        // console.log(JSON.stringify(response.data));
                        if (response.data.success && isMountedRef.current) {
                            const companyId = response.data.Company;
                            const isCompanyActive = await checkCompanyIsActive(companyId);
                            if (!isCompanyActive && !isRedirectingRef.current) {
                                isRedirectingRef.current = true;
                                localStorage.clear();
                                queryClient.clear();
                                await signOut({ redirect: false });
                                router.replace(
                                    "/?err=" +
                                    encodeURIComponent("Company is inactive. Please contact Admin")
                                );
                                return;
                            }
                            document.cookie = "jwt=" + response.data.token;
                            localStorage.setItem("jwt", response.data.token);
                            localStorage.setItem('userId', userid);
                            localStorage.setItem("globalid", userid);
                            localStorage.setItem('roles', response.data.roles);
                            localStorage.setItem("_id", response.data.userid);
                            localStorage.setItem("company", response.data.companyName);
                            localStorage.setItem("name", response.data.username);

                            const mdata = await queryClient.fetchQuery({
                                queryKey: ['menuBar'],
                                queryFn: async () => {
                                    const options = {
                                        headers: { jwt: session.user.token },
                                    };
                                    const result = await axios.post(ApiUrl.newUrl + '/api/GetMenuBarData', "", options);

                                    const data = result.data;

                                    if (data) {
                                        localStorage.setItem('menubardata', JSON.stringify(data.data));
                                    }
                                    return data.data;
                                },
                                staleTime: staleTime,
                                gcTime: gcTime
                            });

                            let sideMenuArr = [];
                            try {
                                const menuBar = response.data.menubar;
                                sideMenuArr = menuBar?.dashboard?.[1]?.sideMenu || [];
                                if (sideMenuArr && sideMenuArr.length > 0) {
                                    sideMenuArr.forEach((item) => {
                                        if (item["URL"]) {
                                            router.prefetch(item["URL"]);

                                        }
                                    });
                                }
                            } catch (err) {
                                console.error('Failed to parse menubardata:', err);
                            }
                            await update();
                            if (['Admin', 'Internal User', 'Internal Admin', 'External User', 'Internal Manager'].includes(session?.user?.roles)) {
                                // Redirect after successful login
                                if (jobid && id) {
                                    router.push(`/jobs/approvals?jobtype=${jobtype}&jobid=${jobid}&id=${id}`);
                                } else if (redirectTo) {
                                    router.push(`/${redirectTo}`);
                                } else {
                                    router.push(getDefaultRouteFromMenu());
                                }
                            }
                        } else if (response.data.message === "User is inactive") {
                            localStorage.clear();
                            queryClient.clear();
                            await signOut({ redirect: false });
                            router.replace(
                                "/?err=" +
                                encodeURIComponent("Your account is not active please contact Admin")
                            );
                            return;
                        }
                        else {
                            // alert("Login failed");
                            signOut();
                        }
                        // })
                        // .catch(function (error) {
                        //     console.log(error);
                        //     // alert("Login failed");
                        //     signOut();
                        // });
                    }
                    else if (session.user.userid) {
                        // Redirect after successful login
                        if (session.user.isNewUser != true) {
                            if (!isMountedRef.current) return;
                            if (session?.user?.company) {
                                const isCompanyActive = await checkCompanyIsActive(session.user.company);
                                if (!isCompanyActive && !isRedirectingRef.current) {
                                    isRedirectingRef.current = true;

                                    localStorage.clear();
                                    queryClient.clear();
                                    await signOut({ redirect: false });
                                    router.replace(
                                        "/?err=" +
                                        encodeURIComponent("Company is inactive. Please contact Admin")
                                    );
                                    return;
                                }

                            }
                            setIsNewUser(false);
                            document.cookie = "jwt=" + session.user.token;
                            localStorage.setItem('jwt', session.user.token);
                            localStorage.setItem('userId', session.user.emailid);
                            session.user.email = session.user.emailid;
                            localStorage.setItem("globalid", session.user.emailid);
                            localStorage.setItem('roles', session.user.roles);
                            localStorage.setItem("_id", session.user.userid);
                            localStorage.setItem("company", session.user.companyName);
                            localStorage.setItem("name", session.user.name);

                            const data = await queryClient.fetchQuery({
                                queryKey: ['menuBar'],
                                queryFn: async () => {
                                    const options = {
                                        headers: { jwt: session.user.token },
                                    };
                                    const res = await axios.post(ApiUrl.newUrl + '/api/GetMenuBarData', "", options);
                                    return res.data;
                                },
                                staleTime: staleTime,
                                gcTime: gcTime
                            });
                            if (data && isMountedRef.current) {
                                localStorage.setItem('menubardata', JSON.stringify(data.data));

                                let sideMenuArr = [];

                                try {
                                    let menuBar = data.data;

                                    if (typeof menuBar === "string") {
                                        menuBar = JSON.parse(menuBar);
                                    }

                                    if (menuBar?.menubar) {
                                        menuBar = menuBar.menubar;
                                    }

                                    const dashboardItems = menuBar?.dashboard;

                                    if (Array.isArray(dashboardItems)) {
                                        let matchedDash = dashboardItems.find(item => item.defaultMenu);
                                        if (!matchedDash) matchedDash = dashboardItems[0];

                                        sideMenuArr = matchedDash?.sideMenu || [];
                                    }

                                    // Prefetch URLs
                                    sideMenuArr.forEach(item => {
                                        if (item.URL) router.prefetch(item.URL);
                                    });

                                    // Redirect logic
                                    if (jobid && id) {
                                        router.push(`/jobs/approvals?jobtype=${jobtype}&jobid=${jobid}&id=${id}`);
                                    } else if (redirectTo) {
                                        router.push(`/${redirectTo}`);
                                    } else {
                                        router.push(getDefaultRouteFromMenu());
                                    }

                                } catch (err) {
                                    console.error('Failed to parse menubardata:', err);
                                }
                            }


                            // })
                            // .catch((error) => {
                            //     console.error('Error fetching menu bar data:', error);
                            // });

                        }
                        else {
                            if (isMountedRef.current) setIsNewUser(true);
                        }
                    }
                    else {
                        // alert("Login failed");
                        signOut();
                        document.cookie = 'jwt=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
                        localStorage.clear();
                        queryClient.clear();
                    }
                } catch (error) {
                    if (axios.isCancel(error)) {
                        console.log('Login request cancelled');
                    } else {
                        console.error('Login error:', error?.message);
                        signOut();
                        queryClient.clear();
                    }
                }
            } else if (session && localStorage.getItem("jwt")) {
                const allowedRoles = ['Admin', 'Internal User', 'Internal Admin', 'External User', 'Internal Manager'];
                if (session?.user?.roles?.some(role => allowedRoles.includes(role))) {
                    // Redirect if already logged in
                    if (jobid && id) {
                        router.push(`/jobs/approvals?jobtype=${jobtype}&jobid=${jobid}&id=${id}`);
                    } else if (redirectTo) {
                        router.push(`/${redirectTo}`);
                    } else {
                        router.push(getDefaultRouteFromMenu());
                    }
                }
                // }else{
                //     router.push('/');
            }
        }
        handleLogin();

        return () => {
            isMountedRef.current = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [session, redirectTo, router]);

    if (session) {


        return (
            <>
                <div>

                    {isNewUser && <div className={styles.loginPage}> <ResetPassModal isOpen={resetPassOpen} onRequestClose={setResetPassOpen} /></div>}


                </div>
            </>
        );
    } else {
        return (<SignOut />);
    }
}
